module.exports = __webpack_public_path__ + "static/media/email.ada25132.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/email.svg
// module id = 94
// module chunks = 0